// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  Button,
  FormControl,
  Select,
  MenuItem,
  Grid,
  TextField,
  Box,
  Dialog,
  Link,
} from '@material-ui/core';

// import Modal from 'react-responsive-modal';
import {
  resetRegistrationAction,
  getUserTypeAction,
  handleLoginModalAction,
  openRegisterModalAction,
  sendOtp,
  getFarmConnectUserTypeAction,
  resetOtpAction,
} from '../../Actions/appAction';
// import { Link } from 'react-router-dom';

import Carousel from './carousel';
import SocialLogin from './socialLogin';
import MobileLogin from './mobileLogin';
import FarmerRegistration from './farmerRegistration';
import LanguageContext from '../common/languageContext';
import { languageConverter } from '../../Functions/helper';
import { isMobile } from '../../Functions/commonValidation';

class RegisterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openMobile: false,
      accountType: '9b5b09a0-e70f-9020-fc9a-edf5c54d0a7a',
      accountTypeName: 'Insurance',
      accountValue: '9b5b09a0-e70f-9020-fc9a-edf5c54d0a7a//Insurance',
      mobileNumber: '',
      mobileError: false,
    };
    // this.handleAccountType = this.handleAccountType.bind(this);
  }

  componentDidMount() {
    const { /* getUserType, */ getFarmConnectUserType } = this.props;
    // getUserType()
    getFarmConnectUserType();
  }

  componentDidUpdate(prevProps) {
    const { otpError, otp } = this.props;
    if (prevProps.otpError === '' && otpError !== '') {
      this.handelUpdate(false);
    }
    if (prevProps.otp === '' && otpError === '' && otp !== '') {
      this.handelUpdate(true);
    }
  }

  handelUpdate = (value) => {
    this.setState({
      openMobile: value,
    });
  };

  handleOpen = (ev) => {
    if (ev.key !== 'Tab') {
      this.setState({
        open: true,
      });
    }
  };

  handleClose = () => {
    const { resetRegistration } = this.props;
    this.setState({
      open: false,
      openMobile: false,
    });
    resetRegistration();
  };

  _handleOpenMobileLogin = (bool) => {
    this.setState({
      openMobile: bool,
    });
  };

  _getOtp = (type, ev) => {
    if (ev.key !== 'Tab') {
      const { getLogin } = this.props;
      const { mobileNumber } = this.state;
      const mobileErrorCheck = !isMobile(mobileNumber);
      this.setState({
        mobileError: mobileErrorCheck,
      });
      if (!mobileErrorCheck) {
        getLogin(mobileNumber, 'SIGNUP', type);
      }
    }
  };

  _handleState = (type, event) => {
    const { resetOtp } = this.props;
    if (type === 'mobileNumber') {
      if (event.target.value.length <= 10) {
        resetOtp();
        this.setState({
          mobileNumber: event.target.value,
          mobileError: false,
        });
      }
    }
  };

  _renderLoginButtons = () => {
    const { language } = this.context;
    const {
      accountType,
      accountTypeName,
      accountValue,
      mobileNumber,
      mobileError,
    } = this.state;
    const { otpError } = this.props;
    return (
      <div>
        {/* <h5> */}
        {/* {(language.hindi */}
        {/* && language.hindi['you can create an account from']) */}
        {/* || 'you can create an account from '} */}
        {/* </h5> */}
        <ul className="modalButtons">
          <li>
            {/* <TextField
              label="Mobile No."
              className="textField inputHead customText-width"
              margin="normal"
            /> */}
            <TextField
              id="standard-uncontrolled"
              label={
                (language.hindi && language.hindi['Mobile No.']) || 'Mobile No.'
              }
              className="textField inputHead customText-width"
              margin="normal"
              value={mobileNumber}
              onChange={event => this._handleState('mobileNumber', event)}
              error={!!mobileError}
              helperText={mobileError ? 'Please enter valid mobile number' : ''}
            />
          </li>
          {/* <li className="darkgreenBtnHeader">
            <Button
              variant="contained"
              className="button darkgreenBtn"
              onClick={() => this._handleOpenMobileLogin(true)}
            >
              {(language.hindi && language.hindi.Mobile) || 'Request OTP'}
            </Button>
          </li> */}
          <p
            className="errorMsg"
            style={{ textAlign: 'center', marginBottom: '5px' }}
          >
            {otpError}
          </p>
          <div className="darkgreenBtnHeader">
            <Button
              variant="contained"
              color="primary"
              className="button darkgreenBtn"
              onClick={ev => this._getOtp('SMS', ev)}
            >
              {(language.hindi && language.hindi.Submit) || 'Request OTP'}
            </Button>
          </div>
          {/* <div className="darkgreenBtnHeader">
            <Button
              variant="contained"
              className="button darkgreenBtn"
              onClick={() => this._handleOpenMobileLogin(true)}
            >
              {(language.hindi && language.hindi.Mobile) || 'Request OTP'}
            </Button>
          </div> */}
          {/* <li className="orText">
            {(language.hindi && language.hindi.or) || 'or'}
          </li> */}
          <SocialLogin
            accountType={accountType}
            accountTypeName={accountTypeName}
            accountValue={accountValue}
          />
          <li className="orText">
            {(language.hindi && language.hindi.or)
              || 'Already have an account?'}
            <Link
              to="/"
              className="regisetrLink"
              onClick={() => this.handleOpenLogin(true)}
            >
              Login
            </Link>
          </li>
        </ul>
      </div>
    );
  };

  handleAccountType = (e) => {
    // debugger;
    this.setState({
      accountType: e.target.value.split('//')[0],
      accountTypeName: e.target.value.split('//')[1],
      accountValue: e.target.value,
    });
  };

  handleBackBtn = () => {
    this.setState({
      openMobile: false,
    });
  };

  moveToPricing = (e) => {
    e.preventDefault();
    const { history } = this.props;
    history.push('/chooseplan');
  };

  handleOpenLogin(bool) {
    const { handleLoginModal, openRegisterModalFun } = this.props;
    this.setState({
      open: false,
    });
    handleLoginModal(bool);
    openRegisterModalFun(false);
  }

  render() {
    const {
      open,
      openMobile,
      accountValue,
      accountType,
      accountTypeName,
      mobileNumber,
    } = this.state;
    const {
      isMobileVerified,
      isRegistered,
      openRegisterModal,
      userType,
    } = this.props;
    console.log(
      ' accountType, accountTypeName, accountValue',
      accountType,
      accountTypeName,
      accountValue,
    );
    const { language } = this.context;
    console.log('isMobileVerified', isMobileVerified);
    return (
      <div>
        <Button
          // role="button"
          onClick={this.handleOpen}
          tabIndex="0"
          className="siFoloBtn"
        >
          {(language.hindi && language.hindi.Register) || 'Register'}
        </Button>
        <Dialog
          maxWidth={false}
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={open || openRegisterModal}
        >
          {/* <Modal
          open={open || openRegisterModal}
          onClose={this.handleClose}
          showCloseIcon={false}
          closeOnOverlayClick={false}
          center
        > */}
          <div className="registerModal modalHead">
            <div className="paper modalCarousel">
              <div
                role="button"
                tabIndex="0"
                className="modalCloseIcon mobileCloseIcon"
                onClick={this.handleClose}
                onKeyDown={this.handleClose}
              >
                <i className="material-icons">close</i>
              </div>
              <Grid container>
                {!isRegistered ? (
                  <Box display={{ xs: 'block', sm: 'none' }}>
                    <Grid item>
                      <Carousel />
                    </Grid>
                  </Box>
                ) : null}
                {/* <Grid md={7} lg={7}>hhdfdfhdff</Grid>
                <Grid md={5} lg={5}>dfddg</Grid> */}
                <Grid
                  item
                  sm={7}
                  xs={12}
                  md={7}
                  lg={7}
                  className={
                    !isRegistered ? 'modalSec ' : 'modalSec  successHeader'
                  }
                >
                  {!isMobileVerified ? (
                    <div className="modalSec">
                      <React.Fragment>
                        {!openMobile && (
                          <>
                            <h5 className="main-heading">Register</h5>
                            <h4 className="createAccountHeading">
                              {(language.hindi && language.hindi.Register)
                                || 'Create an account as'}
                              <FormControl className="formControl inputHead coloredForms">
                                <Select
                                  disableUnderline
                                  name="sifolo-user"
                                  className="selectEmpty modalDropdown"
                                  inputProps={{ 'aria-label': 'user' }}
                                  onChange={e => this.handleAccountType(e)}
                                  value={accountValue}
                                  displayEmpty
                                >
                                  <MenuItem value="" disabled>
                                    Select User
                                  </MenuItem>
                                  {userType.map(item => (
                                    <MenuItem
                                      value={`${item.organisationTypeID}//${item.organisationTypeName}`}
                                      key={item.organisationTypeID}
                                    >
                                      {languageConverter(
                                        item.organisationTypeName,
                                        language.hindi,
                                      )}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </h4>
                          </>
                        )}
                        {openMobile ? (
                          <MobileLogin
                            handleOpenMobileLogin={this._handleOpenMobileLogin}
                            mobileNumber={mobileNumber}
                            resendOtp={this._getOtp}
                            handleBackBtn={this.handleBackBtn}
                          />
                        ) : (
                          this._renderLoginButtons()
                        )}
                      </React.Fragment>
                    </div>
                  ) : (
                    <FarmerRegistration
                      accountType={accountType}
                      accountTypeName={accountTypeName}
                    />
                  )}
                </Grid>
                {!isRegistered ? (
                  <Grid
                    item
                    sm={5}
                    xs={12}
                    md={5}
                    lg={5}
                    className="modal-back-img button-info"
                  >
                    <Box display={{ xs: 'none', sm: 'block' }}>
                      <div className="button-area">
                        <div className="modalHeading">
                          <h4>Benefits for Joining Us!</h4>
                          <div
                            role="button"
                            tabIndex="0"
                            className="modalCloseIcon"
                            onClick={this.handleClose}
                            onKeyDown={this.handleClose}
                          >
                            <i className="material-icons">clear</i>
                          </div>
                        </div>
                        <ul>
                          <li>
                            <a href="/">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="customise-circle"
                              >
                                <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                              </svg>
                              Your Farm Rating
                            </a>
                          </li>
                          <li>
                            <a href="/">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="customise-circle"
                              >
                                <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                              </svg>
                              Get Insurance
                            </a>
                          </li>
                          <li>
                            <a href="/">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="customise-circle"
                              >
                                <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                              </svg>
                              Get Insurance
                            </a>
                          </li>
                          <li>
                            <a href="/">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="customise-circle"
                              >
                                <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                              </svg>
                              Expert Visit
                            </a>
                          </li>
                          <li>
                            <a href="/">
                              {' '}
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="customise-circle"
                              >
                                <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                              </svg>
                              Farmguide Credit Card
                            </a>
                          </li>
                          <li>
                            <a href="/">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="customise-circle"
                              >
                                <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                              </svg>
                              Expert Visit
                            </a>
                          </li>
                          <li>
                            <a href="/">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                className="customise-circle"
                              >
                                <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                              </svg>
                              Government Subsidy
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="downloadBtn">
                        <Button onClick={this.moveToPricing}>
                          <i />
                          Our subscriptions
                        </Button>
                        <Button>
                          <i />
                          Download farmguide App
                        </Button>
                      </div>
                    </Box>
                  </Grid>
                ) : null}
              </Grid>
            </div>
          </div>
        </Dialog>

        {/* Successful Registration Modal */}
      </div>
    );
  }
}

RegisterModal.contextType = LanguageContext;

export default withRouter(
  connect(
    ({ app }) => ({
      isRegistered: app.isRegistered,
      isMobileVerified: app.isMobileVerified,
      openRegisterModal: app.openRegisterModal,
      userType: app.userType,
      otpError: app.otpError,
      otp: app.otp,
    }),
    dispatch => ({
      resetRegistration: () => dispatch(resetRegistrationAction()),
      getUserType: () => dispatch(getUserTypeAction()),
      getFarmConnectUserType: () => dispatch(getFarmConnectUserTypeAction()),
      handleLoginModal: bool => dispatch(handleLoginModalAction(bool)),
      openRegisterModalFun: bool => dispatch(openRegisterModalAction(bool)),
      getLogin: (mobile, otpType, device) => dispatch(sendOtp(mobile, otpType, device)),
      resetOtp: () => dispatch(resetOtpAction()),
    }),
  )(RegisterModal),
);
